<script lang="ts">
  import { customerList, listExcluded } from '$lib/api/lists';
  import { scheduleCount } from '$lib/stores/guided';
  import CustomerListPanel from '$lib/components/CustomerListPanel.svelte';

  /**
   * The last question of the guide: is there anything you already have?
   *
   * It comes last because it is the only step that subtracts. Every step before
   * it describes who the customer is looking for; this one takes away the ones
   * they need not be shown, and asking it before the selection exists would be
   * asking somebody to remove companies from nothing.
   */

  /**
   * Re-count whenever the subtraction changes, as every other step does.
   *
   * The list itself is watched as well as the switch, because a list is still
   * being matched while this step is on screen: rows resolve behind it, and the
   * number beside the price has to follow them down rather than describing the
   * selection as it was when the file landed.
   */
  $: void ($listExcluded, $customerList, scheduleCount());
</script>

<div class="max-w-2xl">
  <CustomerListPanel roomy />
</div>
